import React, { useEffect } from "react";
import Steps from "./common/steps";
import { useLocation, useNavigate } from 'react-router-dom';
import { helpers } from "@shared";

const StepsProduct = () => {

    const navigate = useNavigate(), location = useLocation();
    const { orgDueDay } = location.state;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const steps = [
        {
            title: `Payment timeline`,
            description: `Pay by the ${helpers.dayOrdinal(orgDueDay)}, or pay us back on your timeline`
        },
        {
            title: `Payment preferences`,
            description: `Configure automatic payments`
        },
        {
            title: `Add other payors`,
            description: `Add family members to help pay the bill`
        }
    ];

    return (
        <div className="page-content-wrapper">
            <h1 className="page-header">You’re almost ready to enroll in Sunbound</h1>
            <span className="page-subheader">Complete these easy steps to enroll in Sunbound for this month (and future months also!)</span>
            <Steps steps={steps} />
            <div className="page-action">
                <button type="button" className="btn btn-primary" onClick={() => helpers.navigateNext(location, navigate)}>Continue</button>
            </div>
        </div>
    );
};


export default StepsProduct;